import script from "./BaseModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseModal.vue?vue&type=script&setup=true&lang=ts"

import "./BaseModal.vue?vue&type=style&index=0&id=db7e6d6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db7e6d6e"]])

export default __exports__